module.exports = __webpack_public_path__ + "img/neye.d380a815.png";